// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__YeodS","title":"styles_title__DS3Tl","actions":"styles_actions__czHWd","description":"styles_description__6I7Jf"};